/**
 * SPA-only warmup for world-map entry. Terrain/UI atlases ship through startup blob preload
 * (`WORLD_MAP_*` URLs in vercelBlobPreloadUrls.ts) plus Pixi warmup in ensureVercelBlobPreload.
 */
let apiWarmKickStarted = false

export function warmWorldMapConfig(): void {
  if (apiWarmKickStarted) return
  apiWarmKickStarted = true
  void import('./worldMapApi')
    .then((m) => m.getWorldConfig())
    .catch(() => {})
}
